import app from './app';
import error from './error';
import user from './user';

const reducers = {
  user,
  app,
  error,
};

export default reducers;
